import React from 'react';
import { Link as RouteLink } from 'react-router-dom';
import Utils from '../utils';
import UI from '../ui';

const { Link } = UI;

const { Session } = Utils;

export const LegalList = () => {
	const { brandName = '' } = Session.getBrand();

	return (
		<div className="common-terms legal-list">
			<h2 className="terms-title">Legal Terms</h2>
			<div className="terms-list">
				<ul>
					<li>
						<RouteLink to="/terms/WebClient" dataqa="legal-webclient-terms-link">
							{brandName} Web Client Terms of Use
						</RouteLink>
					</li>
					<li>
						<RouteLink to="/terms/General" dataqa="legal-service-terms-link">
							{brandName} Service Terms and Conditions
						</RouteLink>
					</li>
					<li>
						<Link href="https://auctane.com/legal/privacy-policy/" dataqa="legal-privacy-policy-link">
							{brandName} Privacy Policy
						</Link>
					</li>
				</ul>
			</div>
		</div>
	);
};
